import React, { useState } from "react";
import { MessageCircle, X, Send } from "lucide-react";
import { api } from "@/lib/api";

export const ChatWidget = () => {
  const [open, setOpen] = useState(false);
  const [msgs, setMsgs] = useState([{ from: "bot", text: "Welcome to K.O Chef & Catering! How can we help plan your event?" }]);
  const [text, setText] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const send = async () => {
    if (!text.trim()) return;
    const userMsg = text;
    setMsgs((m) => [...m, { from: "user", text: userMsg }]);
    setText("");
    try {
      const { data } = await api.post("/chat", { name: name || "Guest", email, message: userMsg });
      setMsgs((m) => [...m, { from: "bot", text: data.reply }]);
      setSent(true);
    } catch {
      setMsgs((m) => [...m, { from: "bot", text: "Something went wrong. Please call us directly." }]);
    }
  };

  return (
    <>
      <button
        data-testid="chat-toggle"
        onClick={() => setOpen(!open)}
        className="fixed bottom-6 right-6 z-40 w-14 h-14 bg-gold text-black flex items-center justify-center shadow-2xl hover:bg-gold-dark transition-colors"
        aria-label="Live chat"
      >
        {open ? <X /> : <MessageCircle />}
      </button>
      {open && (
        <div data-testid="chat-window" className="fixed bottom-24 right-6 z-40 w-[92vw] max-w-sm bg-[#0b0b0b] border border-white/10 flex flex-col shadow-2xl">
          <div className="bg-black/60 border-b border-white/10 p-4">
            <p className="font-serif text-lg text-white">Chat with us</p>
            <p className="text-xs text-white/50">Typically replies within minutes</p>
          </div>
          <div className="p-4 h-64 overflow-y-auto no-scrollbar space-y-3">
            {msgs.map((m, i) => (
              <div key={i} className={`text-sm max-w-[85%] px-3 py-2 ${m.from === "bot" ? "bg-white/5 text-white/80" : "bg-gold text-black ml-auto"}`}>{m.text}</div>
            ))}
          </div>
          {!sent && (
            <div className="px-4 pb-2 grid grid-cols-2 gap-2">
              <input value={name} onChange={(e)=>setName(e.target.value)} placeholder="Name" className="lux-input !py-2 !text-sm" data-testid="chat-name" />
              <input value={email} onChange={(e)=>setEmail(e.target.value)} placeholder="Email" className="lux-input !py-2 !text-sm" data-testid="chat-email" />
            </div>
          )}
          <div className="p-4 flex gap-2 border-t border-white/10">
            <input value={text} onChange={(e)=>setText(e.target.value)} onKeyDown={(e)=>e.key==="Enter"&&send()} placeholder="Type a message…" className="lux-input !py-2 !text-sm" data-testid="chat-input" />
            <button onClick={send} className="w-10 h-10 bg-gold text-black flex items-center justify-center shrink-0" data-testid="chat-send"><Send className="w-4 h-4"/></button>
          </div>
        </div>
      )}
    </>
  );
};

export default ChatWidget;
